// import { useState, useEffect } from "react";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import "./location.css";

// const SimpleLocation = ({autoDetected}) => {
//   const [location, setLocation] = useState({
//     city: "Detecting...",
//     country: "",
//   });
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const detectLocation = async () => {
//       try {
//         const position = await new Promise((resolve, reject) => {
//           navigator.geolocation.getCurrentPosition(resolve, reject, {
//             timeout: 5000,
//           });
//         });

//         const { latitude, longitude } = position.coords;
//         const response = await fetch(
//           `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
//         );
//         const data = await response.json();
//         console.log("Location data:", data);

//         const city =
//           data.address?.city ||
//           data.address?.town ||
//           data.address?.state ||
//           "Nearby area";
//         const country = data.address?.country || "";

//         setLocation({ city, country });
//       } catch (err) {
//         console.error("Location detection failed:", err);
//         setError("Unable to detect location");
//         setLocation({ city: "Location unavailable", country: "" });
//       }
//     };

//     detectLocation();
//   }, []);

//   return (
//     <div className="location-display">
//       <FaMapMarkerAlt className="location-icon" size={30} style={{color:"red"}} />
//       <div className="location-text">
//         <span className="city">{autoDetected.city}</span>
//         {autoDetected.country_name && (
//           <span className="country">{autoDetected.country_name}</span>
//         )}
//       </div>
//       {error && <div className="error-message">{error}</div>}
//     </div>
//   );
// };

// export default SimpleLocation;
import { useState, useEffect } from "react";
import { MapPin } from "lucide-react";

const SimpleLocation = ({ autoDetected }) => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const detectLocation = async () => {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: 5000,
          });
        });

        const { latitude, longitude } = position.coords;
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        );
        const data = await response.json();
      } catch (err) {
        console.error("Location detection failed:", err);
        setError("Unable to detect location");
      }
    };

    detectLocation();
  }, []);

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 10px",
      borderRadius: "20px",
      fontSize: "14px",
      maxWidth: "fit-content"
    }}>
      <MapPin 
        size={18} 
        style={{ 
          color: error ? "#999" : "#ef4444",
          flexShrink: 0 
        }} 
      />
      
      {error ? (
        <span style={{
          color: "#999",
          fontSize: "13px",
          whiteSpace: "nowrap"
        }}>
          Location unavailable
        </span>
      ) : (
        <span style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "180px",
          fontWeight: 500
        }}>
          {autoDetected.city}
          {autoDetected.country_name && (
            <span style={{ 
              color: "#666",
              fontWeight: 400,
              marginLeft: "4px"
            }}>
              , {autoDetected.country_name}
            </span>
          )}
        </span>
      )}
    </div>
  );
};

export default SimpleLocation;